<div class="backdrop" fxLayoutAlign="center center" (click)="onBack()">
  <div class="modal-wrapper" (click)="$event.stopPropagation()">
    <h3>{{ modalContent.title | translate }}</h3>
    <p>{{ modalContent.content | translate }}</p>
    <div class="mt-40" fxLayoutAlign="space-between center">
      <lns-button [buttonContent]="backButton" (click)="onBack()">{{
        'common_info_no' | translate
      }}</lns-button>
      <lns-button
        [buttonContent]="confirmLinkButton"
        (click)="openLink(locationLink)"
        >{{ 'common_info_yes' | translate }}</lns-button
      >
    </div>
  </div>
</div>
